import React from 'react';

export class Card extends React.Component {

    render() {

        const classCard = this.props.center ? 'card card--center' : 'card';

		return (
			<div className={classCard}>
                <div className="card-media">
                    {this.props.media}
                </div>
                <div className="card-content card-content--inline">
                    {this.props.children}
                </div>
                {this.props.meta}
            </div>
      	)
	}
};


export class CardInline extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            isInlineOpen: false
        }

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        const isInlineOpen = 1 - this.state.isInlineOpen;
        this.setState({isInlineOpen});
    }

    render() {


        const classCard = this.props.center ? 'card card--center' : 'card';
        const classContent = this.state.isInlineOpen ? 'card-content' : 'card-content card-content--inline';

		return (
			<div className={classCard} onClick={this.handleToggle}>
                <div className="card-media card-media--inline">
                    {this.props.media}
                </div>
                <div className={classContent}>
                    {this.props.children}
                </div>
                {this.props.meta}
            </div>
      	)
	}
};


// WEBPACK FOOTER //
// ./src/components/chunk/Card.js